class NovaPriceRange extends HTMLElement {
  constructor() {
    super()
    this.sliderColor = '#d9dbda'
    this.rangeColor = '#C5A7FD'
  }

  connectedCallback() {
    const minSlider = this.querySelector('.js-filter__price-range-min')
    const maxSlider = this.querySelector('.js-filter__price-range-max')
    const minInput = this.querySelector('.js-filter__price-number-min')
    const maxInput = this.querySelector('.js-filter__price-number-max')
    const minSliderSubstitute = this.querySelector(
      '.js-filter__price-range-min-substitute'
    )
    this.fillSlider(
      minSlider,
      maxSlider,
      this.sliderColor,
      this.rangeColor,
      maxSlider,
      minSliderSubstitute,
    )
    this.setToggleAccessible(minSlider, maxSlider)

    minSlider.addEventListener('input', () =>
      this.controlMinSlider(
        minSlider,
        maxSlider,
        minInput,
        minSliderSubstitute,
      )
    )
    maxSlider.addEventListener('input', () =>
      this.controlMaxSlider(
        minSlider,
        maxSlider,
        maxInput,
        minSliderSubstitute,
      )
    )
    minInput.addEventListener('input', () =>
      this.controlMinInput(
        minSlider,
        minInput,
        maxInput,
        maxSlider,
        minSliderSubstitute,
        maxSlider
      )
    )
    maxInput.addEventListener('input', () =>
      this.controlMaxInput(
        maxSlider,
        minInput,
        maxInput,
        minSlider,
        minSliderSubstitute,
        minSlider
      )
    )
  }

  controlMinInput(
    minSlider,
    minInput,
    maxInput,
    controlSlider,
    minSliderSubstitute,
    maxSlider
  ) {
    const [from, to] = this.getParsed(minInput, maxInput)
    this.fillSlider(
      minInput,
      maxSlider,
      this.sliderColor,
      this.rangeColor,
      controlSlider,
      minSliderSubstitute,
    )
    this.setToggleAccessible(minSlider, controlSlider)

    const fromValue = !isNaN(from) ? from : 0
    const toValue = !isNaN(to) ? to : 0

    if (isNaN(to)) {
      minSlider.value = from
      minInput.value = from.toFixed(2)
    } else if (fromValue > toValue) {
      minSlider.value = to
      minInput.value = to.toFixed(2)
      maxInput.value = from.toFixed(2)
      maxSlider.value = from
    } else {
      minSlider.value = from
      minInput.value = from.toFixed(2)
      maxInput.value = to.toFixed(2)
      maxSlider.value = to
    }
  }

  controlMaxInput(
    maxSlider,
    minInput,
    maxInput,
    controlSlider,
    minSliderSubstitute,
    minSlider
  ) {
    const [from, to] = this.getParsed(minInput, maxInput)
    this.fillSlider(
      minSlider,
      maxInput,
      this.sliderColor,
      this.rangeColor,
      maxSlider,
      minSliderSubstitute
    )

    const fromValue = !isNaN(from) ? from : 0
    const toValue = !isNaN(to) ? to : 0

    this.setToggleAccessible(controlSlider, maxSlider)
    if (isNaN(from)) {
      maxSlider.value = toValue
      maxInput.value = toValue.toFixed(2)
    } else if (fromValue <= toValue) {
      maxSlider.value = toValue
      maxInput.value = toValue.toFixed(2)
    } else {
      maxInput.value = fromValue.toFixed(2)
      maxSlider.value = fromValue
      minInput.value = toValue.toFixed(2)
      minSlider.value = toValue
    }
  }

  controlMinSlider(
    minSlider,
    maxSlider,
    minInput,
    minSliderSubstitute,
  ) {
    const [from, to] = this.getParsed(minSlider, maxSlider)
    this.fillSlider(
      minSlider,
      maxSlider,
      this.sliderColor,
      this.rangeColor,
      maxSlider,
      minSliderSubstitute,
    )
    this.setToggleAccessible(minSlider, maxSlider)
    if (from > to) {
      minSlider.value = to
      minInput.value = to.toFixed(2)
    } else {
      minInput.value = from.toFixed(2)
    }
  }

  controlMaxSlider(
    minSlider,
    maxSlider,
    maxInput,
    minSliderSubstitute,
  ) {
    const [from, to] = this.getParsed(minSlider, maxSlider)
    this.fillSlider(
      minSlider,
      maxSlider,
      this.sliderColor,
      this.rangeColor,
      maxSlider,
      minSliderSubstitute,
    )
    this.setToggleAccessible(minSlider, maxSlider)
    if (from <= to) {
      maxSlider.value = to
      maxInput.value = to.toFixed(2)
    } else {
      maxInput.value = from.toFixed(2)
      maxSlider.value = from
    }
  }

  getParsed(currentFrom, currentTo) {
    const minFrom = parseFloat(currentFrom.min)
    const maxFrom = parseFloat(currentFrom.max)
    const minTo = parseFloat(currentTo.min)
    const maxTo = parseFloat(currentTo.max)
    let from = parseFloat(currentFrom.value)
    let to = parseFloat(currentTo.value)

    from = Math.min(Math.max(from, minFrom), maxFrom)
    to = Math.min(Math.max(to, minTo), maxTo)

    return [from, to]
  }

  fillSlider(
    from,
    to,
    sliderColor,
    rangeColor,
    controlSlider,
    minSliderSubstitute,
  ) {
    const rangeDistance = to.max - to.min
    const fromPosition = from.value - to.min
    const toPosition = to.value - to.min

    // Set the z-index of the min thumb substitute
    fromPosition > toPosition
      ? (minSliderSubstitute.style.zIndex = 0)
      : (minSliderSubstitute.style.zIndex = 10)

    const fromPercent = fromPosition === 0 ? 0 : fromPosition / rangeDistance
    const toPercent = toPosition === 0 ? 0 : toPosition / rangeDistance

    minSliderSubstitute.style.left = `calc(${fromPercent * 100}% - ${
      fromPercent * 14
    }px)`

    // Set the background of the slider bar between two thumbs
    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${fromPercent * 100}%,
      ${rangeColor} ${fromPercent * 100}%,
      ${rangeColor} ${toPercent * 100}%,
      ${sliderColor} ${toPercent * 100}%,
      ${sliderColor} 100%
    )`
  }

  setToggleAccessible(minSlider, maxSlider) {
    if (
      Number(minSlider.value) === Number(maxSlider.value) &&
      Number(maxSlider.value) === Number(maxSlider.max)
    ) {
      maxSlider.style.zIndex = 0
    } else {
      maxSlider.style.zIndex = 4
    }
  }
}

customElements.define('nova-price-range', NovaPriceRange)
